import { CategoryApplicantAnswersReviewStep } from './CategoryApplicantAnswersReviewStep';
import useCategoryFeedbackFormHandling from './useCategoryFeedbackFormHandling';
import { DietaryHabitsAndHealthUIConfig } from '../../../shared/CategoryStepUIConfig';
import { useApplicantAnswersReview } from './useApplicantAnswersReview';
import { useAuth } from '../../../hooks/useAuth';
import { UserRole } from '../../../shared/VolunteerApplicationServiceTypes';

const UiConfig = DietaryHabitsAndHealthUIConfig;

export const DietaryHabitsAndHealthAnswersReviewStep = () => {
	const { dietaryHabitsAndHealth, setDietaryHabitsAndHealth, application } =
		useApplicantAnswersReview();
	const { role } = useAuth();
	const isAdminOrApprover =
		role === UserRole.APPROVER || role === UserRole.ADMIN;
	const { form } = useCategoryFeedbackFormHandling(
		dietaryHabitsAndHealth,
		setDietaryHabitsAndHealth
	);

	return (
		<CategoryApplicantAnswersReviewStep
			uiConfig={UiConfig}
			form={form}
			answers={application?.userAnswers}
			showCheckbox
			disable={isAdminOrApprover}
		/>
	);
};
